<template>
  <div v-if="invoiceNo">
    <div class="ticket">
      <img v-if="logo" :src="logo" alt="Logo" />
      <p class="centered" style="margin-bottom: 10px">
        <span v-if="!logo">{{ name }}</span> <br />
        {{ address }}
        <br />{{ telephone }} <br />
      </p>

      <p v-if="type === 'invo'">
        Inovice No : {{ invoiceNo }} <br />Date :
        {{ date }} <br />Cashier : {{ cashier }}
        <br />Customer : {{ customerName }}
      </p>
      <p v-if="type === 'quota'">
        Quotation No : {{ invoiceNo }} <br />Date :
        {{ date }} <br />Cashier : {{ cashier }}
        <br />Customer : {{ customerName }}
      </p>
      <p v-if="type === 'po'">
        PO No : {{ invoiceNo }} <br />Date : {{ date }}
        <br />Supplier : {{ supplierName }}
      </p>
      <table style="margin-top: -30px">
        <thead>
          <tr style="border-top: hidden">
            <th class="description" style="text-align: left">Item</th>
            <th class="unitprice" style="text-align: left">Price</th>
            <th class="quantity" style="text-align: left">Qty</th>
            <th class="price" style="text-align: left">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" :key="product.barcode">
            <td class="description">{{ product.name }} {{ product.serial }}</td>
            <td class="price">{{ product.price.toLocaleString() }}</td>
            <td class="quantity">{{ product.quantity }}</td>
            <td class="price">{{ (product.price*product.quantity).toLocaleString() }}</td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr style="border-top: 1px solid rgb(49, 49, 49)">
            <td class="description">Bill Total</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ grossAmount.toLocaleString() }}</td>
          </tr>
          <tr>
            <td class="description">Product Discount</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ discount.toLocaleString() }}</td>
          </tr>
          <tr v-if="otherDiscount">
            <td class="description">Other Discount</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ otherDiscount.toLocaleString() }}</td>
          </tr>
          <tr v-if="sCharge">
            <td class="description">Service Charge</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ sCharge.toLocaleString() }}</td>
          </tr>
          <tr v-if="dilCharge">
            <td class="description">Delivery Charge</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ dilCharge.toLocaleString() }}</td>
          </tr>
          <tr>
            <td class="description">Net Total</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ (netAmount + dilCharge).toLocaleString() }}</td>
          </tr>
          <tr v-if="tax">
            <td class="description">Tax</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ tax.toLocaleString() }}</td>
          </tr>
          <tr v-if="cardPayment">
            <td class="description">Card</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ cardPayment.toLocaleString() }}</td>
          </tr>
          <tr v-if="cashPayment">
            <td class="description">Cash</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ cashPayment === netAmount ? (cashPayment + dilCharge).toLocaleString() : (cashPayment).toLocaleString()}}</td>
          </tr>
          <tr v-if="chequePayment">
            <td class="description">Cheque</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ chequePayment.toLocaleString() }}</td>
          </tr>
          <tr v-if="loyalityPoints">
            <td class="description">Loyalty Points</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ loyalityPoints }}</td>
          </tr>
          <tr v-if="giftVouchers">
            <td class="description">Gift Vouchers</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ giftVouchers.toLocaleString() }}</td>
          </tr>
          <tr v-if="!dilCharge">
            <td class="description">Balance</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ balance.toLocaleString() }}</td>
          </tr>
          <tr v-if="remaining">
            <td class="description">Remaining</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ (remaining + dilCharge).toLocaleString() }}</td>
          </tr>
          <tr v-if="customer">
            <td class="description">Earned Loyalty Points</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ earnedLoyalityPoints }}</td>
          </tr>
          <tr v-if="customer && totalLoyalityPoints">
            <td class="description">Total Loyalty Points</td>
            <td class="quantity"></td>
            <td class="quantity"></td>
            <td class="price">{{ totalLoyalityPoints }}</td>
          </tr>
          <tr>
            <br />
          </tr>
        </tbody>
      </table>
      <p class="centered" style="margin-bottom: 10px">
        Thanks for your purchase! <br />Come again.
      </p>
      <p class="centered">{{ footer }}</p>
    </div>
  </div>
</template>

<script>
import { type } from "os";

export default {
  name: "posprinter",
  props: [
    "products",
    "invoiceNo",
    "cashier",
    "grossAmount",
    "discount",
    "otherDiscount",
    "tax",
    "sCharge",
    "dilCharge",
    "netAmount",
    "cardPayment",
    "cashPayment",
    "chequePayment",
    "giftVouchers",
    "balance",
    "remaining",
    "loyalityPoints",
    "earnedLoyalityPoints",
    "totalLoyalityPoints",
    "address",
    "telephone",
    "logo",
    "name",
    "footer",
    "customer",
    "customerName",
    "supplierName",
    "type",
    "date"
  ],
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped>
td,
th,
tr,
table {
  border-top: 1px dotted rgb(49, 49, 49);
  border-collapse: collapse;
}
.centered {
  text-align: center;
  align-content: center;
}

* {
  font-size: 12px;
  font-family: "Times New Roman";
}
td.description,
th.description {
  width: 80px;
  max-width: 85px;
}

td.quantity,
th.quantity {
  width: 20px;
  max-width: 25px;
  word-break: break-all;
}

td.unitprice,
th.unitprice {
  width: 50px;
  max-width: 50px;
  word-break: break-all;
}

td.price,
th.price {
  width: 30px;
  max-width: 30px;
  word-break: break-all;
}

.ticket {
  /* width: 185px;
  max-width: 185px; */
  width: 210px;
  max-width: 210px;
}

/* * {
  font-size: 18px;
  font-family: "Times New Roman";
}

td.description,
th.description {
  width: 320px;
  max-width: 320px;
}

td.quantity,
th.quantity {
  width: 120px;
  max-width: 120px;
  word-break: break-all;
}

td.unitprice,
th.unitprice {
  width: 180px;
  max-width: 180px;
  word-break: break-all;
}

td.price,
th.price {
  width: 180px;
  max-width: 180px;
  word-break: break-all;
}

.ticket {
  width: 800px;
  max-width: 800px;
  margin: 0 auto;
} */

img {
  max-width: 180px;
  width: 180px;
  display: block;
  margin: 0 auto;
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/InvoiceTemplates/POSPrinter.vue